var _rect, _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBackgroundTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 800,
    viewBox: "0 0 1080 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -100,
    width: 1280,
    height: 800,
    fill: "url(#paint0_linear_2_513)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M889.776 580.62C849.703 574.374 810.09 565.246 772.024 553.215L770.257 558.641L808.496 568.877L781.665 669.107L698.14 646.748L724.971 546.518L764.681 557.148L766.535 551.456C714.073 534.421 664.677 511.823 621.235 483.606L624.64 478.364C667.582 506.257 716.479 528.631 768.47 545.513L770.403 539.579L775.884 541.364L773.96 547.272C835.193 566.622 900.546 578.419 965.404 582.709C980.369 583.699 995.301 584.29 1010.15 584.481L1010.36 580.524L1016.11 580.83L1015.91 584.535C1056.54 584.777 1096.45 582.023 1134.47 576.302L1134.31 575.646L1139.91 574.295L1140.18 575.417C1197.46 566.302 1250.28 550.385 1294.58 527.76L1297.43 533.326C1252.59 556.223 1199.31 572.295 1141.65 581.512L1143.25 588.151L1184.3 579.327L1206.11 680.769L1121.57 698.943L1099.76 597.501L1137.62 589.363L1135.94 582.401C1097.3 588.245 1056.78 591.042 1015.58 590.783L1015.15 598.975L1054.73 598.965L1054.76 702.725L968.292 702.745L968.267 598.986L1009.38 598.976L1009.81 590.727C994.935 590.531 979.976 589.937 964.992 588.946C941.824 587.413 918.582 584.929 895.476 581.488L893.677 591.673L933.533 599.733L912.967 701.433L828.216 684.295L848.782 582.594L888.026 590.53L889.776 580.62Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.178,
    y: 607.368,
    width: 69.1729,
    height: 69.1729,
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 731.409,
    y: 556.921,
    width: 69.1729,
    height: 69.1729,
    transform: "rotate(14.9863 731.409 556.921)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 855.853,
    y: 592.578,
    width: 69.1729,
    height: 69.1729,
    transform: "rotate(11.4323 855.853 592.578)",
    fill: "#7386FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9515 587.115C-3.59568 586.261 -44.0722 582.489 -83.4005 575.633L-84.4293 581.246L-45.1676 586.3L-58.4136 689.21L-144.172 678.172L-130.926 575.262L-90.1547 580.509L-89.0754 574.621C-143.338 564.723 -195.303 548.904 -242.115 526.722L-239.439 521.074C-193.165 543.001 -141.725 558.664 -87.9486 568.474L-86.8233 562.334L-81.1534 563.374L-82.2736 569.486C-19.0088 580.51 47.3331 583.5 112.185 579.116C127.148 578.105 142.026 576.701 156.763 574.915L156.444 570.965L162.19 570.502L162.489 574.2C202.787 569.03 241.971 560.987 278.888 550.255L278.644 549.626L284.018 547.54L284.436 548.617C339.992 531.956 390.219 509.148 431.117 480.825L434.675 485.963C393.286 514.626 342.621 537.649 286.704 554.461L289.176 560.829L328.681 546.617L363.802 644.252L282.441 673.52L247.319 575.886L283.75 562.78L281.158 556.103C243.648 567.04 203.861 575.207 162.992 580.436L163.652 588.613L202.883 583.333L216.723 686.165L131.03 697.699L117.189 594.867L157.931 589.383L157.266 581.149C142.495 582.936 127.589 584.339 112.606 585.352C89.4406 586.918 66.0754 587.55 42.7167 587.217L42.2901 597.55L82.8642 600.231L76.023 703.765L-10.255 698.064L-3.41375 594.53L36.5365 597.17L36.9515 587.115Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.137,
    y: 601.987,
    width: 69.1729,
    height: 69.1729,
    transform: "rotate(-7.66557 127.137 601.987)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.54,
    y: 580.759,
    width: 69.1729,
    height: 69.1729,
    transform: "rotate(-19.7851 258.54 580.759)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.92261,
    y: 603.484,
    width: 69.1729,
    height: 69.1729,
    transform: "rotate(3.78045 4.92261 603.484)",
    fill: "#7386FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.218 377.678C761.047 359.855 691.626 331.976 633 293.896L636.83 288C694.683 325.578 763.327 353.165 835.8 370.827L836.761 366.664L842.955 368.094L841.983 372.307C886.634 382.811 932.655 389.569 978.434 392.597C979.698 392.681 980.962 392.762 982.226 392.84L983.036 385.16L989.359 385.827L988.58 393.208C1033.43 395.637 1077.87 394.477 1120.38 389.766L1119.84 386.904L1126.09 385.738L1126.71 389.036C1194.49 380.924 1257.14 363.702 1308.4 337.524L1311.6 343.786C1259.6 370.339 1196.31 387.744 1128 395.963L1128.98 401.192L1174.7 393.829L1192.89 506.814L1098.74 521.978L1080.54 408.993L1122.7 402.203L1121.67 396.696C1078.45 401.517 1033.31 402.691 987.841 400.209L987.256 405.757L1030.86 408.02L1024.93 522.307L929.687 517.364L935.618 403.077L980.898 405.427L981.487 399.839C980.315 399.766 979.142 399.691 977.969 399.613C931.862 396.563 885.462 389.756 840.401 379.158L838.914 385.6L882.351 396.766L853.858 507.603L761.494 483.859L789.986 373.022L832.755 384.016L834.218 377.678Z",
    fill: "#B9D3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.951,
    y: 412.821,
    width: 76.2939,
    height: 76.2939,
    transform: "rotate(2.97079 944.951 412.821)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 797.2,
    y: 384.425,
    width: 76.2939,
    height: 76.2939,
    transform: "rotate(14.4168 797.2 384.425)",
    fill: "#7386FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.382 376.678C327.553 358.855 396.974 330.976 455.6 292.896L451.77 287C393.916 324.578 325.273 352.165 252.8 369.827L251.839 365.664L245.644 367.094L246.617 371.307C201.966 381.811 155.944 388.569 110.166 391.597C108.902 391.681 107.638 391.762 106.374 391.84L105.564 384.16L99.2408 384.827L100.02 392.208C55.1732 394.637 10.734 393.477 -31.7784 388.766L-31.2441 385.905L-37.4939 384.738L-38.1099 388.036C-105.894 379.924 -168.54 362.702 -219.802 336.524L-223 342.786C-171.003 369.339 -107.708 386.744 -39.4031 394.963L-40.3795 400.192L-86.0954 392.829L-104.291 505.814L-10.1371 520.978L8.05884 407.993L-34.1006 401.203L-33.0724 395.696C10.1505 400.517 55.2848 401.691 100.758 399.209L101.344 404.757L57.7424 407.02L63.6736 521.307L158.913 516.364L152.982 402.077L107.702 404.427L107.112 398.839C108.285 398.766 109.457 398.691 110.63 398.613C156.738 395.563 203.138 388.756 248.199 378.158L249.686 384.6L206.249 395.766L234.742 506.603L327.106 482.859L298.613 372.022L255.845 383.016L254.382 376.678Z",
    fill: "#B9D3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76.2939,
    height: 76.2939,
    transform: "matrix(-0.998656 0.0518269 0.0518269 0.998656 143.648 411.821)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76.2939,
    height: 76.2939,
    transform: "matrix(-0.96851 0.248974 0.248974 0.96851 291.399 383.425)",
    fill: "#7386FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.58 134.323C1187.16 130.822 1095 119.694 1004.2 96.936L1005.52 90.9778L991.323 87.8356L990.111 93.3084C812.852 46.4338 641.584 -45.6965 506.911 -213L499 -206.632C635.435 -37.1387 808.877 55.9565 987.915 103.229L984.549 118.436L903.757 101.898L861.544 308.122L1033.4 343.3L1075.61 137.076L998.794 121.352L1002 106.852C1093.55 129.77 1186.33 140.954 1276.18 144.471L1276.58 134.323Z",
    fill: "#BBD7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 917.425,
    y: 122.602,
    width: 140.334,
    height: 140.334,
    transform: "rotate(11.5685 917.425 122.602)",
    fill: "#5B9AFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-199.928 137.401C-114.696 147.656 -22.8385 143.161 69.7244 110.612L66.5909 102.183L80.2183 97.1168L83.3751 105.608C179.573 68.9036 276.218 1.22889 366.678 -112.323L374.622 -105.995C282.916 9.12025 184.729 77.8292 86.9143 115.128L90.0897 123.669L167.495 99.4962L230.244 300.427L62.8024 352.718L0.0527542 151.788L76.1924 128.01L73.2638 120.132C-20.8872 153.269 -114.397 157.921 -201.141 147.484L-199.928 137.401Z",
    fill: "#BBD7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.0264,
    y: 163.303,
    width: 140.334,
    height: 140.334,
    transform: "rotate(-17.3433 22.0264 163.303)",
    fill: "#5B9AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_513",
    x1: 540,
    y1: 0,
    x2: 540,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9AAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBackgroundTablet);
export default __webpack_public_path__ + "static/media/BlueBackgroundTablet.738d2feef386452c3bea.svg";
export { ForwardRef as ReactComponent };